import { LoadingState } from "@/ds/custom/LoadingState";
import { useClonePublicCollection } from "@/features/collections/api/useClonePublicCollection";
import { ErrorDisplay } from "@/lib/common/ErrorDisplay";
import { Limit } from "@/lib/common/Limit";
import { useEffectOnFirstMount } from "@/lib/common/useEffectOnFirstMount";
import { useNotifyMutationSuccess } from "@/lib/common/useNotifyMutationSuccess";
import { useQueryParams } from "@/lib/common/useQueryParams";
import type { Currency } from "@/lib/domain/Currency";
import type { PriceSource } from "@/lib/domain/PriceSource";
import { useEffect, type FC } from "react";
import { useNavigate, useParams } from "react-router";

export const PageClonePublicCollectionRedirect: FC = () => {
	const params = useParams();
	const queryParams = useQueryParams();
	const shareToken = params.shareToken as string;
	const currency = queryParams.get("currency") as Currency;
	const priceSource = queryParams.get("priceSource") as PriceSource;

	const clonePublicCollection = useClonePublicCollection(shareToken, currency, priceSource);
	useNotifyMutationSuccess(clonePublicCollection, "Collection Cloned");

	const navigate = useNavigate();

	useEffectOnFirstMount(() => {
		clonePublicCollection.mutate();
	});

	useEffect(() => {
		if (!clonePublicCollection.isSuccess) {
			return;
		}

		navigate(`/collections/${clonePublicCollection.data.body.collectionId}`);
	}, [clonePublicCollection.isSuccess]);

	return (
		<Limit border>
			{
				clonePublicCollection.isPending &&
				<LoadingState />
			}

			<ErrorDisplay error={clonePublicCollection.error} />
		</Limit>
	);
};
